import Service from "../../AuthService";

const Standard = {
    getStandard(data) {
        return Service.get(`/standard?page=${data.page}&type=${data.type}`);
    },
    showStandard(id) {
        return Service.get(`/standard/` + id);
    },
    saveStandard(data) {
        return Service.post("/standard", data);
    },
    deleteStandard(id) {
        return Service.delete("/standard/" + id);
    },
    getWeight(data) {
        return Service.get(`/weight?type=${data.type}&month=${data.month}`);
    },
    showWeight(id) {
        return Service.get(`/weight/` + id);
    },
    saveWeight(data) {
        return Service.post("/weight", data);
    },
    deleteWeight(id) {
        return Service.delete("/weight/" + id);
    },
    deleteWeightDaily(data) {
        return Service.post("/weight-delete-daily", data);
    },
    getCostList(data) {
        return Service.get(`/cost?page=${data.page}&type=${data.type}`);
    },
    getPlasticList(data) {
        return Service.get(`/plastic?page=${data.page}&type=${data.type}`);
    },
    showCost(id) {
        return Service.get(`/cost/` + id);
    },
    saveCost(data) {
        return Service.post("/cost", data);
    },
    savePlastic(data) {
        return Service.post("/plastic", data);
    },
    deleteCost(id) {
        return Service.delete("/cost/" + id);
    },
};
export default Standard;
